import { toast } from "sonner";
import { Flex, IconButton } from "@radix-ui/themes";
import { CopyIcon } from "@radix-ui/react-icons";
import { TextWithTooltip } from "@/components/shared/tooltip/TextWithTooltip";

export function TicketIdFormatter({ value }: { value: string }) {
  return (
    <Flex
      gap="2"
      align="center"
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
      }}
    >
      <TextWithTooltip size="1" color="gray" truncate>
        {`#${value}`}
      </TextWithTooltip>

      <IconButton
        variant="soft"
        size="1"
        color="gray"
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          navigator.clipboard.writeText(value);
          toast.success("Copied to clipboard");
        }}
      >
        <CopyIcon />
      </IconButton>
    </Flex>
  );
}
